import { makeAutoObservable } from "mobx";

import type { TGameCategoryRubricator } from "@/api";
import { GameCategoryRubricatorAPI } from "@/api/modules/game-category-rubricator";
import Query from "@/models/query";

const DEFAULT_GAME_RUBRICATOR_ID = 1;

export class GameCategoryRubricatorStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  private _rubricator: TGameCategoryRubricator[] = [];
  private _selectedId: number = DEFAULT_GAME_RUBRICATOR_ID;

  get rubricator() {
    return this._rubricator;
  }

  get selectedId() {
    return this._selectedId;
  }

  get selectedItem() {
    return this._rubricator.find((item) => item.id === this._selectedId);
  }

  private setRubricators(rubricator: TGameCategoryRubricator[]) {
    this._rubricator = rubricator;
  }

  setSelectedId(id?: number) {
    this._selectedId = id ?? DEFAULT_GAME_RUBRICATOR_ID;
  }

  clearSelected() {
    this._selectedId = DEFAULT_GAME_RUBRICATOR_ID;
  }

  gameCategoryRubricatorQuery = new Query(GameCategoryRubricatorAPI.getAll);

  async fetch() {
    await this.gameCategoryRubricatorQuery.submit({});

    if (!this.gameCategoryRubricatorQuery.isFulfilled) {
      return;
    }

    const { data } = this.gameCategoryRubricatorQuery.data;
    this.setRubricators(data);
  }
}
